import React from "react";
import block from "bem-cn-lite";

const b = block("RequestFormsInput");

export default ({ name, value, description, onChange, invalid }) => (
    <textarea 
        value={value}
        className={b({ multiline: true, invalid })} 
        onChange={(e) => onChange({name, value: e.target.value}) } />
);
